namespace GeniuzPOS.PosShift {
    export interface ReportSaleTaxRow {
        Id?: string;
        DocDate?: string;
        PosId?: string;
        PosPermitNo?: string;
        DocType?: number;
        StartDocNo?: string;
        EndDocNo?: string;
        NonVatAmt?: number;
        ExVatAmt?: number;
        VatAmt?: number;
        TotalAmt?: number;
    }

    export namespace ReportSaleTaxRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PosId';
        export const localTextPrefix = 'PosShift.ReportSaleTax';
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายงานภาษีขาย:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            PosId = "PosId",
            PosPermitNo = "PosPermitNo",
            DocType = "DocType",
            StartDocNo = "StartDocNo",
            EndDocNo = "EndDocNo",
            NonVatAmt = "NonVatAmt",
            ExVatAmt = "ExVatAmt",
            VatAmt = "VatAmt",
            TotalAmt = "TotalAmt"
        }
    }
}
